import React from 'react';
import _get from 'lodash.get';
import Layout from 'components_v2/desktop/Layout';
import { loadLayoutDataUSHP } from 'reduxUtils/modules_v2/layout';
import { loadAuthorDetails } from '../../redux';
import AuthorPage from './author';

const pageName = 'authorLandingPage';

async function action(context) {
  const dataPromiseArray = [];
  const localParams = { 0: context.path }; // #todo-aff : check if needed
  let status = 200;
  let state = context.store.getState();
  const isReviewsPage = state.isTOIReviews;

  const isPrime = !!state.isPrime;
  const { params: { id, name } = {} } = context || {};
  const newParams = {
    ...localParams,
    id,
    name,
    fullPath: context.pathname,
    isWapView: false,
    isPrime,
    frmapp: context.query.frmapp,
    query: context.query,
    isReviewsPage,
  };

  if (!_get(state, 'authorpage.data')) {
    dataPromiseArray.push(context.store.dispatch(loadAuthorDetails(newParams)));
  }
  if (!state.header.data || !state.footer_v2.data) {
    dataPromiseArray.push(
      context.store.dispatch(loadLayoutDataUSHP(newParams)),
    );
  }

  // #todo-aff :  confirm layout feed and parameter -- ask rahul
  if (typeof window === 'undefined') {
    await Promise.all(dataPromiseArray);
  }

  state = context.store.getState();
  const { authorpage: authorPageData = {} } = state || {};

  let dataAvailable = !!state.authorpage;

  if (
    state.authorpage &&
    state.authorpage.j_message &&
    !state.authorpage.sections
  ) {
    dataAvailable = false;
  }

  if (typeof window === 'undefined' && !dataAvailable) {
    status = 404;
  }
  // author name
  const title = _get(state, 'authorpage.meta_data.seo.title') || 'Author page';
  const seoData = _get(state, 'authorpage.meta_data.seo', {});
  const authorName = _get(
    authorPageData,
    'pageData.author.personalprofile.displayname',
  );
  const bio = _get(authorPageData, 'pageData.author.personalprofile.bio');

  seoData.title = `${authorName}: Read Latest News from ${authorName} - Times of India`;
  seoData.description = bio;
  const authorNameCapitalized = authorName
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('-');
  seoData.canonical = `https://timesofindia.indiatimes.com/toireporter/author-${authorNameCapitalized}-${id}.cms`;
  if (isReviewsPage) {
    seoData.canonical = `https://reviews.indiatimes.com/author/${authorNameCapitalized}/${id}`;
    seoData.title = `${authorName}: Read latest reviews from ${authorName} - Times Reviews`;

    seoData['google-site-verification'] =
      'ZgFICIedNvVZl5pV9EfAUeenwta9vBY0Za_GgmV4zuw';
  }

  const getComponent = pageTitle => {
    if (typeof window === 'undefined' && !dataAvailable) {
      return (
        <div>
          Something went wrong. Click{' '}
          <a href="https://reviews.indiatimes.com">here</a> to browse
          reviews.indiatiems.com
        </div>
      );
    }
    //#todo-aff : need to check , props used in india homepage for layout
    //#todo-aff : match navigaton with india homepage
    return (
      <Layout
        title={pageTitle}
        params={newParams}
        query={Object.keys(context.query).length ? context.query : {}}
        hideAdBlockerDetector
        pageType="authorPage"
        hideCyclicNav
        showWeatherInC
        hideAds
        hideAdCude
        isReviewsPage={isReviewsPage}
      >
        <AuthorPage id={id} data={authorPageData} />
      </Layout>
    );
  };
  // #todo-aff : pick all seo details from feed.
  return {
    title,
    chunks: ['author_page_desktop'],
    seoData,
    status,
    component: getComponent(title),
    scrollRestoration: 'auto', //#todo-aff : need to check , requirements and analyze
    maxAge: 900,

    gaData: {
      dimension9: pageName,
    },
    isPrime,
    skipRouteAds: true,
    isAffiliatePage: true,
  };
}

export default action;
